import { TAG_USER_ROLES, TAG_USER_TYPES } from "../../data/tags";
import BuildSettings from "../buildSettings";
import AccountUtil from "./accountUtil";
import TagsUtil from "./tagsUtils";

export default class TagPermissions {

    static getUserTags = (loggedInUser, account, allTags) => {

        const isOwner = account && account.email === loggedInUser.email;

        if(isOwner){
            // allTags.forEach(tag => {
            //     tag.users = tag.users.filter(tagUser => tagUser.email !== loggedInUser.email);
            // });
            return allTags;
        }

        const userTags = [];

        allTags.forEach(tag => {
            // Remove owner user from the each tag's users list
            if(account){
                tag.users = tag.users.filter(tagUser => tagUser.email !== account.email);
            }
            userTags.push(tag);
        });

        return userTags;
    }

    static getUserRavens = (loggedInUser, account, allRavens, allTags) => {

        const subscription = (raven) => {
            if (BuildSettings.billingEnabled && account && account.subscriptions) {
                return AccountUtil.getRavenActiveSubscription(raven.ravenUuid, account.subscriptions);
            }
            else {
                return null;
            }
        }        
        
        const userRavens = [];

        const isOwner = account && account.email === loggedInUser.email;

        if(isOwner){
            userRavens.push(...allRavens);

            userRavens.forEach(raven => {
                // Add subscription to each raven 
                raven.subscription = subscription(raven);
            });
        }
        else {

            let roles = [TAG_USER_ROLES.ADMIN, TAG_USER_ROLES.OWNER];

            const tagIdsMatchingTheRoles = allTags.filter(tag => tag.users.find(tagUser => tagUser.email.toLowerCase() === loggedInUser.email.toLowerCase() && roles.includes(tagUser.role))).map(tag => tag.tagId);

            allRavens.forEach(raven => {
                if(raven.tags.some(tag => tagIdsMatchingTheRoles.includes(tag.tagId))) {
                    userRavens.push(raven);
                }
            });

            const tagIds = allTags.map(tag => tag.tagId);

            userRavens.forEach(raven => {
                // Remove raven's tags to which current user is not assigned
                // A raven can have multiple tags assigned to different users
                // If the cloud already filters the tags based on the user's role, then this step is not needed
                raven.tags = raven.tags.filter(tag => tagIds.includes(tag.tagId));

                // Add subscription to each raven 
                raven.subscription = subscription(raven);
            });
        }

        return userRavens;
    }

    static getUserUsers = (loggedInUser, account, allUsers, allTags, limitToUsersFromTagsWithAdminRole, excludePendingUsers = false) => {

        // Generally only include
        // - Pending users (userId === null)
        // - Users who have tags assigned to them
        let availableUsers = allUsers.filter(user => (user.userId === null) || (user.tags && user.tags.length > 0));
 
        // Exclude pending users if needed/asked
        if(excludePendingUsers)
            availableUsers = availableUsers.filter(user => user.userId !== null);

        if(account){
            const ownerUser = availableUsers.find(user => user.email.toLowerCase() === account.email.toLowerCase());
           
            if(ownerUser) {
                ownerUser.isOwner = true;
            }
        }

        const currentUser = availableUsers.find(user => user.email.toLowerCase() === loggedInUser.email.toLowerCase());
        if(currentUser) {
            currentUser.isCurrentUser = true
        }

        let users = [];

        const isOwner = account && account.email === loggedInUser.email;

        // If current user is the owner, return all users with the owner user at the top
        if(isOwner) {
            availableUsers.forEach(user => {
                if(user.isOwner) {
                    users.unshift(user);
                }
                else {
                    users.push(user);
                }
            });

            return users;
        }


        // If current user is not the owner, 

        // return users which are in the same tags as the current user
        // and exclude the owner user

        allTags.forEach(tag => {
            if(limitToUsersFromTagsWithAdminRole && !tag.canEdit) return;

            const usersWithThisTag = availableUsers.filter(user => user.tags.some(userTag => userTag.tagId === tag.tagId));
            
            usersWithThisTag.forEach(userWithThisTag => {
                const alreadyAdded = users.find(u => u.email === userWithThisTag.email);
                
                if(!alreadyAdded) {
                    if(!userWithThisTag.isOwner) {
                        if(userWithThisTag.isCurrentUser) {
                            users.unshift(userWithThisTag);
                        }
                        else {
                            users.push(userWithThisTag);
                        }
                    }
                }
            });
        });

        // + Pending users
        const pendingUsers = availableUsers.filter(user => user.userId === null);
        users.push(...pendingUsers);

        // Finally
        // Remove users' tags to which current user is not assigned to
        // A user can have multiple tags (to some of them current user is not assigned)
        // TODO: If the cloud already filters the tags based on the user, then this step is not needed
        
        // const tagIds = allTags.map(tag => tag.tagId);
        
        // users.forEach(user => {
        //     if(user.isCurrentUser) return;
        //     user.tags = user.tags.filter(tag => tagIds.includes(tag.tagId));
        // });

        return users;
    }

    static addNewTagToRavens = (newTag, ravens) => {
        ravens.forEach(raven => {
            if(newTag.ravens.find(tagRaven => tagRaven.ravenUuid === raven.ravenUuid)){
                raven.tags.push(TagsUtil.getCopyOfTag(newTag));
            }
        });
    }

    static addTagsToRaven = (raven, tags) => {

        const tagsToAdd = Array.isArray(tags) ? tags : [tags];

        tagsToAdd.forEach(tag => {
            raven.tags.push(TagsUtil.getCopyOfTag(tag));
        });
    }

    static removeDeletedTagFromRavens = (tag, ravens) => {
        ravens.forEach(raven => {
            raven.tags = raven.tags.filter(ravenTag => ravenTag.tagId !== tag.tagId);
        });
    }

    static removeTagsFromRaven = (raven, tags) => {

        const tagsToRemove = Array.isArray(tags) ? tags : [tags];

        const tagsToRemoveIds = tagsToRemove.map(t => t.tagId);

        raven.tags = raven.tags.filter(ravenTag => !tagsToRemoveIds.includes(ravenTag.tagId));
    }

    static addNewTagToUsers = (newTag, users) => {
        users.forEach(user => {
            const tagUser = newTag.users.find(tu => tu.email.toLowerCase() === user.email.toLowerCase());
            if(tagUser){
                user.tags.push(TagsUtil.getCopyOfTag(newTag), {role: tagUser.role});
            }
        });
    }

    static addTagToUser = (user, tag, subTags) => {
        const tagsToAdd = [];

        tagsToAdd.push(TagsUtil.getCopyOfTag(tag, {
            role: TAG_USER_ROLES.GUEST,
            inheritedRole: null,
            userType: TAG_USER_TYPES.OWN_USER
        }));

        subTags.forEach(tag => {
            const alreadyHaveIt = user.tags.find(userTag => userTag.tagId === tag.tagId);
            if(!alreadyHaveIt) {
                tagsToAdd.push(TagsUtil.getCopyOfTag(tag, {
                    role: null,
                    inheritedRole: TAG_USER_ROLES.GUEST,
                    userType: TAG_USER_TYPES.INHERITED_USER
                }));
            }
            else {
                if(alreadyHaveIt.userType === TAG_USER_TYPES.OWN_USER) {
                    alreadyHaveIt.userType = TAG_USER_TYPES.SHARED_USER;
                }
                alreadyHaveIt.inheritedRole = TagsUtil.getHighestRole(alreadyHaveIt.inheritedRole, TAG_USER_ROLES.GUEST);
            }
        });

        user.tags = sortResourceTags([...user.tags, ...tagsToAdd]);
    }

    static removeDeletedTagFromUsers = (tag, users) => {
        users.forEach(user => {
            user.tags = user.tags.filter(userTag => userTag.tagId !== tag.tagId);
        });
    }

    static removeTagFromUser = (user, tag, subTags) => {
        let userTags = user.tags.filter(userTag => userTag.tagId !== tag.tagId);

        subTags.sort((a, b) => parseInt(a.tagId) - parseInt(b.tagId));

        subTags.forEach(subTag => {
            const userTag = userTags.find(userTag => userTag.tagId === subTag.tagId);

            if(userTag) {
                const parentTag = userTags.find(t => t.tagId === userTag.parentTagId);

                if(parentTag) {
                    userTag.inheritedRole = TagsUtil.getHighestRole(parentTag.inheritedRole, parentTag.role);
                }
                else {
                    if(userTag.userType === TAG_USER_TYPES.INHERITED_USER) {
                        userTags = userTags.filter(t => t.tagId !== userTag.tagId);
                    }
                    else {
                        userTag.userType = TAG_USER_TYPES.OWN_USER;
                        userTag.inheritedRole = null;
                    }
                }                
            }
        });

        user.tags = userTags;
    }

    static updateUserTagsInheritance = (user) => {
        const tags = user.tags;

        const newTags = [];

        tags.forEach(tag => {

            const ancestors = tag.ancestors.filter(ancestorId => ancestorId !== tag.tagId);

            if(ancestors.length === 0) {
                newTags.push(tag);
                return;
            }

            const ancestorTags = tags.filter(t => ancestors.includes(t.tagId));            
            tag.inheritedRole = TagsUtil.getHighestRole(...ancestorTags.map(t => t.inheritedRole), ...ancestorTags.map(t => t.role));
            newTags.push(tag);
        });

        user.tags = newTags;
    }

    static updateUserTagRole = (user, tag, role) => {
        user.tags = user.tags.map(userTag => {
            if(userTag.tagId === tag.tagId) {
                userTag.role = role;
                if(userTag.userType === TAG_USER_TYPES.INHERITED_USER) {
                    userTag.userType = TAG_USER_TYPES.SHARED_USER;
                }
            }

            return userTag;
        });
    }

    static setData = (loggedInUser, { tags = [], users = [], ravens = [] } = {}) => {

        if(tags.length > 0) {
            setTags(loggedInUser, tags, users, ravens);
        }

        if(users.length > 0) {
            setUsers(loggedInUser, tags, users, ravens);
        }
        
        if(ravens.length > 0) {
            setRavens(loggedInUser, tags, users, ravens);
        }
    }

    static getUserUniqueTags = (user) => {
        const uniqueTags = [];

        user.tags.forEach(tag => {
            const uniqueTag = uniqueTags.find(t => t.tagId === tag.tagId);

            if (!uniqueTag) {
                uniqueTags.push(tag);
            }
            else{
                uniqueTag.role = TagsUtil.getHighestRole(uniqueTag.role, tag.role);
            }
        });
        
        return uniqueTags;
    }
}

const getUserRole = (role) => {
    if(!role) return;

    return role === TAG_USER_ROLES.OWNER ? TAG_USER_ROLES.ADMIN : role;
}

const sortResourceTags = (tags) => {

    tags.sort((a, b) => parseInt(a.tagId) - parseInt(b.tagId));
    const sortedItems = [];

    tags.forEach(tag => {
        sortedItems.push(tag);
        const descendants = tags.filter(tag => tag.ancestors.includes(tag.tagId) && tag.tagId !== tag.tagId).sort((a, b) => parseInt(a.tagId) - parseInt(b.tagId));
        descendants.forEach(descendant => sortedItems.push(descendant));
    });

    return sortedItems;
}

const setTags = (loggedInUser, tags, users, ravens) => {

    // For each tag set
    // - The userId for tag.users
    // - clear tag.matchedFilters prop if it exists (this can be set in tagsPage when filtering the tags list and used to hightlight the matched tags)

    tags.forEach(tag => {
        if(users.length > 0) {

            const tagUsersWithoutUserId = tag.users.filter(tagUser => !tagUser.userId);
            
            tagUsersWithoutUserId.forEach(tagUser => {
                const user = users.find(user => user.email === tagUser.email);
                if(user) {
                    tagUser.userId = user.userId;
                }
            });
        }

        delete tag.matchedFilters;

        tag.style.fontColor = TagsUtil.getFontColor(tag.style.color);
    });

    tags.sort((a, b) => a.name.localeCompare(b.name));
}

const setUsers = (loggedInUser, tags, users, ravens) => {

    if(!tags || tags.length === 0) {
        console.warn('No tags available. Clearing users tags list.');
        users.forEach(user => {
            user.tags = [];
        });
        return;
    }

    if(tags.length > 0) {

        users.forEach(user => {

            const userTags = user.tags.map(userTag => {

                const tag = tags.find(tag => tag.tagId === userTag.tagId);

                // This user shares this tag with the current user
                if(tag) {
                    const tagUser = tag.users.find(tagUser => tagUser.email === user.email);

                    if(tagUser) {
                        const role = getUserRole(tagUser.role);
                        const inheritedRole = getUserRole(tagUser.inheritedRole);
                        const userType = tagUser.type;
                        return TagsUtil.getCopyOfTag(tag, {role, inheritedRole, userType});
                    }
                }

            }).filter(tag => tag);

            user.tags = sortResourceTags(userTags);
        });
    }
}

const setRavens = (loggedInUser, tags, users, ravens) => {

    if(!tags || tags.length === 0) {
        console.warn('No tags available. Clearing ravens tags list.');
        ravens.forEach(raven => {
            raven.tags = [];
        });
        return;
    }

    // Build a map for quick lookup
    const ravenMap = new Map();
    ravens.forEach(raven => {
        raven.tags = []; // clear any existing tags
        if (raven.ravenUuid) {
            ravenMap.set(raven.ravenUuid, raven);
        }
    });

    // For each tag, assign it to all ravens listed in tag.ravens
    tags.forEach(tag => {
        if (Array.isArray(tag.ravens)) {
            tag.ravens.forEach(tagRaven => {
                const raven = ravenMap.get(tagRaven.ravenUuid);
                if (raven) {
                    raven.tags.push(TagsUtil.getCopyOfTag(tag));
                }
            });
        }
    });

    // Optionally, sort tags for each raven
    ravens.forEach(raven => {
        raven.tags = sortResourceTags(raven.tags);
    });

}